module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEoSURBVGhD7ZlLjgIxEEP7HsAOODyfo4EYOABUbUsxqopJWxrlSd5E9uuI2U2WyWTylZ3lYnla3ivHv3m1HCxdbC03S0u+ZvwOfpcyZ0tLqMjJUuZlackU+bOUiZIq6j0tUO9pgXpPC9R7WqDe0wL1nhao97RAvacF6j0tUO9pgXpPC9T7tAD1queRbA+SFaBe9TyS7UGyAtSrnkeyPUhWgHrV80i2B8kKUK96Hsn2IFkB6lXPI9keJCtAvep5JNuDZAWoVz2PZHsQVqDe0wL1nhao97RAvacF6j0tUO9pgXpPC9R7WqDe0wL1XvIqg9L173V/3mnJFPFnrjJHy93SEq4Zv8Pe0sXG4s87/idsyUfmYfFfvvvykfiBXzPaP/wDo/2TyT9kWT74VccJ4aU4VgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-wardrobe/dark/48.png
// module id = 2541
// module chunks = 2